 
import { Button, MyIcon } from 'ccs-ui-components';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FORM_SERVICE_TYPE } from '../../../../../../constants';
import { useServiceOpsForm } from '../../../../../../hooks';
import { IServiceOperationValidationModel } from '../../../../../../models';
import { useSelector } from '../../../../../../store/AppStore';
import IngressEventForm from '../ingress-event-association/IngressEventForm';
import classes from './ServiceEventAssociationWrapper.module.scss';

interface IServiceEventAssociationWrapperProps {
  serviceOperationData: IServiceOperationValidationModel | undefined;
  serviceOperationName: string;
  operationUrl?: string,
  operationVerb?: string,
  isView: boolean;
  showForms?: () => void,
  showEventForm?: boolean
}

const ServiceEventAssociationWrapper = ({ serviceOperationData, serviceOperationName, operationUrl, operationVerb, showForms, showEventForm, isView }: IServiceEventAssociationWrapperProps) => {
  const { t: translate } = useTranslation();
  const [isBtnValid, setBtnValid] = useState(false);

  const { serviceOperations } = useSelector(
    (state) => state.serviceOperationReducer
  );

  const {
    serviceType: reducerServiceType,
  } = useSelector((state) => state.serviceDetailsReducer);
  const { serviceOpsFormData } = useServiceOpsForm(serviceOperations);

  const handleAccordionButtonClick = () => {
    if (showForms) { showForms(); }
  };

  const businessTypeCheck = () => {
    const serviceTypes = [FORM_SERVICE_TYPE.REST, FORM_SERVICE_TYPE.DB2, FORM_SERVICE_TYPE.MQ];
    const isServiceTypeIncludes = serviceTypes.includes(reducerServiceType?.toLocaleLowerCase());
    if (isView && isServiceTypeIncludes
      && serviceOpsFormData.serviceOperationName.isValid
      && serviceOperationName.length
      && operationVerb?.length
      && serviceOpsFormData.operationURL.isValid) return true;
    if (!isView && isServiceTypeIncludes
      && serviceOperationData?.serviceOperationName.isValid
      && serviceOperationData?.serviceOperationName.value?.length
      && operationVerb?.length
      && serviceOperationData?.operationURL.value?.length
      && serviceOperationData?.operationURL.isValid) return true;
    return false;
  };
  const externalTypeCheck = () => {
    if (isView && reducerServiceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.EXTERNAL
      && serviceOpsFormData.serviceOperationName.isValid
      && serviceOperationName.length) return true;
    if (!isView && reducerServiceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.EXTERNAL
      && serviceOperationData?.serviceOperationName.isValid
      && serviceOperationData?.serviceOperationName.value.length) return true;
    return false;
  };

  const soapTypeCheck = () => {
    if (isView && (reducerServiceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.SOAPSERVICE)
      && serviceOpsFormData.serviceOperationName.isValid
      && serviceOperationName.length) return true;
    if (!isView && (reducerServiceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.SOAPSERVICE)
      && serviceOperationData?.serviceOperationName.isValid
      && serviceOperationData?.serviceOperationName.value.length) { return true; }
    return false;
  };

  useEffect(() => {
    if (businessTypeCheck()) {
      setBtnValid(false);
    } else if (externalTypeCheck() || soapTypeCheck()) {
      if (serviceOpsFormData.operationURL && !serviceOpsFormData.operationURL.isValid) {
        setBtnValid(true);
      } else {
        setBtnValid(false);
      }
    } else {
      setBtnValid(true);
    }
  }, [reducerServiceType, serviceOperationData, operationUrl, operationVerb]);

  /**
   * Displays the Service event association header
   * @returns Header
   */
  const ServiceEventAssociationHeader = () =>
    useMemo(
      () => (
        <>
          <div className={classes['form-header']}>
            {!showEventForm && (
              <MyIcon name="caretRightFillIcon" className={classes['icon-right']} />
            )}
            {showEventForm && (
              <MyIcon name="caretDownFillIcon" className={classes['icon-right']} />
            )}
            <div className={classes['header-title']}>
              {translate('service_event_association.title_service_event_details')}
            </div>
          </div>
          {showEventForm && (
            <div className={classes.subtitle}>
              {translate(
                'service_event_association.sub_title_service_event_details'
              )}
            </div>
          )}
        </>
      ),
      []
    );

  return (
    <div className={classes.container}>
      <Button
        onClick={handleAccordionButtonClick}
        className={classes['form-header-wrapper']}
        disabled={isBtnValid}
        data-testid="btn-wrapper"
        variant="outlined"
      >
        <ServiceEventAssociationHeader />
      </Button>
      {showEventForm && (
        <div className={classes['ing-wrapper']}>
          <IngressEventForm serviceOperationName={serviceOperationName} isView={isView} operationVerb={operationVerb || ''} />
        </div>
      )}
    </div>
  );
};

export default ServiceEventAssociationWrapper;
